
















import { getShopifyId } from 'library/helpers/formatting'

export default

	props:
		product: Object

	data: ->
		loaded: false

	computed:
		productId: -> getShopifyId @product.id

	methods:
		showReviews: ->
			try

				# I want to try and prevent this from
				# loading on subsequent accordions in single page mode...
				await @$loadScript '//staticw2.yotpo.com/DVUJlZcS384JVNmDF2HnlgYzXOqWagUxP9yiQTP5/widget.js'

				# this works on client navigation
				@$wait 100, =>
					api = new Yotpo.API(yotpo)
					api.refreshWidgets()
					@loaded = true

			catch e then console.error "Reviews couldn't load"

